import {useRef, useState} from "react"
import {useSnackbar} from "notistack"
import {ButtonBase, Typography} from "@mui/material"
import {CloudUpload} from "@mui/icons-material"
/**
 * A modified button component using MUI's <ButtonBase> to create a DropZone for client files.
 * The component can also be clicked to trigger opening the file-selection UI.
 *
 * The [handleFileInputChange] param by expects a method that can handle a File.FileList interface.
 *
 * @param {function} [handleFileInputChange] a way to handle the files returned from the client's file selection UI
 * @param {boolean} [multiFile = false] allow multiple files to be uploaded by the user
 * @returns {JSX.Element}
 * @constructor
 */
export default function FileDropzone({handleFileInputChange, multiFile = false}) {
	const [isDraggingFile, setIsDraggingFile] = useState(false)
	const {enqueueSnackbar} = useSnackbar()
	const fileInputRef = useRef(null)


	const handleDragOver = (event) => {
		event.stopPropagation()
		event.preventDefault()
		setIsDraggingFile(true)
	}

	const handleDragLeave = (event) => {
		event.stopPropagation()
		event.preventDefault()
		setIsDraggingFile(false)
	}

	const handleFileDrop = (event) => {
		event.stopPropagation()
		event.preventDefault()
		const isMoz =  !!event.dataTransfer.mozCursor
		setIsDraggingFile(false)
		if (multiFile === false && (!isMoz && event.dataTransfer?.items?.length > 1) ||  (isMoz && event.dataTransfer?.items?.length > 2)  ) {
			enqueueSnackbar("You can only upload one file at a time", {variant: "error", autoHideDuration: 5000})
		} else {
			// create a synthetic Event wrapper that only holds a value of target.files. This is quite hacky, but works across browsers.
			handleFileInputChange({
				target: {
					files: event.dataTransfer.files
				}
			})
		}
	}


	return (
		<ButtonBase
			onDragOver={handleDragOver}
			onDragLeave={handleDragLeave}
			onDrop={handleFileDrop}
			className="DropZone"
			onClick={() => fileInputRef.current.click()}
			sx={{
				display: "flex",
				width: "100%",
				minHeight: "250px",
				alignItems: "center",
				justifyContent: "center",
				border: "4px dashed",
				borderColor: "primary.main",
				borderRadius: "10px",
				backgroundColor: isDraggingFile ? "primary.transparency30" : "primary.transparency10",
			}}
		>
			<CloudUpload size="small" />
			<Typography
				sx={{
					marginLeft: "0.5rem",
				}}
			>
				Upload File
			</Typography>
			<input
				type="file"
				onChange={handleFileInputChange}
				style={{display: "none"}}
				ref={fileInputRef}
			/>
		</ButtonBase>
	)
}